import React from 'react'
import { Box, Container, Link, Typography } from '@material-ui/core' // Importado Typography
import { useTranslation } from 'react-i18next'
import { useStyles } from './Footer.styles'
import {
  logoUFC,
  logoDC,
  logoMDCC,
  logoLSBD,
  logoLinkedin
} from 'src/assets/images'

const Footer = () => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <Box component="footer" className={classes.root}>
      <Container className={classes.container}>
        <Box className={classes.wrapper}>
          <Link
            href="https://www.linkedin.com/company/lsbd---ufc/mycompany/"
            target="_blank"
            rel="noreferrer noopener"
            className={classes.iconLink}
          >
            <img src={logoLinkedin} alt="LinkedIn LSBD" />
          </Link>
          <Box className={classes.logosWrapper}>
            <Link href="https://www.ufc.br/" target="_blank" rel="noreferrer">
              <img src={logoUFC} alt="UFC" />
            </Link>
            <Link href="https://dc.ufc.br" target="_blank" rel="noreferrer">
              <img src={logoDC} alt="Departamento de Computação" />
            </Link>
            <Link href=" https://mdcc.ufc.br/" target="_blank" rel="noreferrer">
              <img src={logoMDCC} alt="MDCC" />
            </Link>
            <Link href="/" rel="noreferrer">
              <img src={logoLSBD} alt="LSBD" />
            </Link>
          </Box>
          <Typography
            className={classes.copyright}
            variant="body2"
            color="textPrimary"
          >
            {t('footer.rights')}
          </Typography>
        </Box>
      </Container>
    </Box>
  )
}

export default Footer
